import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet"
import * as React from "react";

interface HelpPageProps {
  trigger: React.JSX.Element;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

const HomeHelp = ({ trigger, isOpen, onOpenChange }: HelpPageProps) => {
  const handleOpenChange = (newOpen: boolean) => {
    onOpenChange(newOpen);
  };

  // Create a clickable element that is not a button to avoid nesting buttons
  const CustomTrigger = React.forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement>
  >(({ onClick, ...props }, forwardedRef) => (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.currentTarget.click();
        }
      }}
      ref={forwardedRef}
      {...props}
    >
      {trigger}
    </div>
  ));
  CustomTrigger.displayName = "CustomTrigger";

  return (
    <Sheet open={isOpen} onOpenChange={handleOpenChange} modal={true}>
      <SheetTrigger asChild>
        <CustomTrigger />
      </SheetTrigger>
      <SheetContent className="w-[500px] overflow-auto">
        <SheetHeader>
          <SheetTitle>Need Help?</SheetTitle>
        </SheetHeader>
        <div className="space-y-6 mt-6">
          <div className="space-y-4">
            <p className="text-sm">
              If you need assistance, please reach out to the Crimson team at:
            </p>
            <p className="text-sm font-medium text-primary">
              <a 
                href="mailto:support@crimson.law" 
                rel="noopener noreferrer"
                target="_blank">support@crimson.law
              </a>
            </p>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default HomeHelp;